//import $ from 'jquery';

import { View } from 'backbone';
import template  from 'dashboard/link-modal.ejs';
import textUtil from 'util/TextUtil.js';
import util     from 'util/Util.js';

class LinkModal extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.versionInfo = this.options.model.attributes.versionInfo;
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#linkModal";

        let _hostUrl = util.enforceSingleEndSlash(this.model.get('hostUrl'));

        this.model.set('mode', 'window');
        this.model.set('linkText', (window.localStorage.getItem('checkSingleSignOn') && window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase() === 'true' ? window.localStorage.getItem('DirectoryServiceGatewayURL'):_hostUrl) + 'player.htm?f='+this.model.get('link'));
        this.model.set('htmlLinkText', '<a href="'+ (window.localStorage.getItem('checkSingleSignOn') && window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase() === 'true' ? window.localStorage.getItem('DirectoryServiceGatewayURL'):_hostUrl) + 'player.htm?f='+this.model.get('link')+'">'+ this.model.get('name') + '</a>');
        this.model.set('embedText', '<script type="text/javascript" src="' + _hostUrl + 'utils.js"></script><script type="text/javascript">pf_embed("' + (window.localStorage.getItem('checkSingleSignOn') && window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase() === 'true' ? window.localStorage.getItem('DirectoryServiceGatewayURL'):_hostUrl) + 'player.aspx", "'+ this.model.get('id') + '=", "f='+this.model.get('link') + '", "'+this.model.get('width')+'", "'+this.model.get('height')+'", "'+this.model.get('mode')+'"); </script>');
        this.model.set('preloadText', '<script type="text/javascript" src="' + _hostUrl + 'utils.js"></script><script type="text/javascript">pf_preload("' + _hostUrl + 'player.aspx", "'+ this.model.get('id') + '="); </script>');
        this.model.set('externalCallText', '<script type="text/javascript">pf_call("' + this.model.get('id') + '=", [param1, param2, ...]); </script>');
        
        if(this.model.get('apiReference')){
            const reference = this.model.get('apiReference').replace(".asmx","");
            this.model.set('apiReference', _hostUrl + 'api/apps/' + this.model.get('apiReference'));
            this.model.set('restReference', _hostUrl + 'api/REST/' + reference);
        }
        else{
            this.model.set('apiReference', "");
        }

        // PF-5014 Add title with current version
        if (!this.versionInfo || this.versionInfo.isLatest) {
            this.model.set('linkTitle', 'Link to Latest Published Version');
        } else {
            this.model.set('linkTitle', 'Link to Version ' + this.versionInfo.versionNumber);
        }

        return this;
    }

    changeSingleSignOn(event) {
        let _hostUrl = util.enforceSingleEndSlash(this.model.get('hostUrl'));
        
        if(!window.localStorage.getItem('checkSingleSignOn')){
            window.localStorage.setItem('checkSingleSignOn',false);
        }
        window.localStorage.setItem('checkSingleSignOn',event.target.checked);

        this.model.set('linkText', (event.target.checked ? window.localStorage.getItem('DirectoryServiceGatewayURL') : _hostUrl) +'player.htm?f='+this.model.get('link'));
        this.model.set('htmlLinkText', '<a href="'+ ( event.target.checked ? window.localStorage.getItem('DirectoryServiceGatewayURL') : _hostUrl) +'player.htm?f='+this.model.get('link')+'">'+ this.model.get('name') + '</a>');
        this.model.set('embedText', '<script type="text/javascript" src="' + _hostUrl + 'utils.js"></script><script type="text/javascript">pf_embed("' + (event.target.checked ? window.localStorage.getItem('DirectoryServiceGatewayURL') : _hostUrl) + 'player.aspx", "'+ this.model.get('id') + '=", "f='+this.model.get('link')+'", "'+this.model.get('width')+'", "'+this.model.get('height')+'", "'+this.model.get('mode')+'"); </script>');

        $('#linkText').val(this.model.get('linkText'));
        $('#htmlLinkText').val(this.model.get('htmlLinkText'));
        $('#embedText').text(this.model.get('embedText'));
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        let _hostUrl = util.enforceSingleEndSlash(this.model.get('hostUrl'));

        this.model.set(propName, propVal);
        this.model.set('embedText', '<script type="text/javascript" src="' + _hostUrl + 'utils.js"></script><script type="text/javascript">pf_embed("' + (window.localStorage.getItem('checkSingleSignOn') && window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase() === 'true' ? window.localStorage.getItem('DirectoryServiceGatewayURL'):_hostUrl) + 'player.aspx", "'+ this.model.get('id') + '=", "f='+this.model.get('link') + '", "'+this.model.get('width')+'", "'+this.model.get('height')+'", "'+this.model.get('mode')+'"); </script>');
        $('#embedText').text(this.model.get('embedText'));
    }

    bindEvents() {
        if(!window.localStorage.getItem('checkSingleSignOn')){
            window.localStorage.setItem('checkSingleSignOn',false);
        }

        $('input[type=checkbox][name=singleSignOn]').prop("checked",textUtil.stringToBoolean(window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase()));

        $('input[type=radio][name=mode]').on("change", (e)=>{
            this.updateRadioAttributes(e);
        });
        $('input[type=checkbox][name=singleSignOn]').on("change", (e)=>{
            this.changeSingleSignOn(e);
        });

        $(".share-button").on("click", (ev)=>{
            const current = $(ev.currentTarget);
            const textArea = current.parent().find("textarea");

            if(current.hasClass("link")){
                util.copyValue(textArea[0].id);
            }
            else{
                window.open(textArea[0].value, "_blank");
            }
        });
    }

    unbindEvents() {
        $('input[type=radio][name=mode]').off();
        $('input[type=checkbox][name=singleSignOn]').off();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            const body = $('body');
            body.append(this.$el);

            var self = this;
           
            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 700,
                minWidth: 650, 
                minHeight: 475,
                maxWidth: body.width(), 
                maxHeight: body.height(),
                modal: true,
                resizable: true,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': false,
                        click: () => {
                            self.unbindEvents();
                            this.dialog.dialog( "close" );
                            resolve('OK');
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () => {
                    $(self.El).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');       
                    self.bindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default LinkModal;
